import React, { ReactNode } from "react"
import Grid, { GridProps } from "@mui/material/Grid"
import classNames from "classnames"

interface GridItemProps {
   children?: ReactNode
   xs?: number
   sm?: number
   md?: number
   lg?: number
   size?: GridProps["size"]
   className?: GridProps["className"]
}

const GridItem: React.FC<GridItemProps> = ({
   children,
   xs = 12,
   sm = 6,
   md = 4,
   lg = 1,
   size,
   className,
}) => {
   const gridSize = size ?? {
      xs: xs,
      sm: sm,
      md: md,
      lg: lg,
   }
   return (
      <Grid
         className={classNames(className)}
         size={gridSize}
      >
         {children}
      </Grid>
   )
}

export default GridItem
